// src/api/endpoints.ts

// API Endpoints
const ENDPOINTS = {
  // V2 Architecture Base URL
  API_V2_BASE_URL: import.meta.env.VITE_API_V2_BASE_URL,
  
  // Menu API Paths (New - V2 Architecture)
  MENU_ITEMS_API_PATH: import.meta.env.VITE_MENU_ITEMS_API_PATH,
  MENU_ITEM_DETAILS_API_PATH: import.meta.env.VITE_MENU_ITEM_DETAILS_API_PATH,
  
  // Website API Paths (V2 - New endpoints)
  SITE_CONTENT_VIEW_API_PATH: import.meta.env.VITE_SITE_CONTENT_API_PATH,
  SITE_CONTENT_UPDATE_API_PATH: import.meta.env.VITE_SITE_CONTENT_API_PATH,
  DOMAIN_API_PATH: import.meta.env.VITE_DOMAIN_API_PATH,
  
  // Restaurant API Paths (uses same endpoint as DOMAIN_API_PATH)
  RESTAURANT_DETAILS_API_PATH: import.meta.env.VITE_DOMAIN_API_PATH,
  
  // Categories & Modifiers API Paths
  CATEGORIES_API_PATH: import.meta.env.VITE_CATEGORIES_API_PATH,
  MODIFIER_GROUPS_API_PATH: import.meta.env.VITE_MODIFIER_GROUPS_API_PATH,
  MODIFIER_OPTIONS_API_PATH: import.meta.env.VITE_MODIFIER_OPTIONS_API_PATH,

  // Order API Paths
  ORDER_API_PATH: import.meta.env.VITE_ORDER_API_PATH,
  PAYMENT_STATUS_UPDATE_API_PATH: import.meta.env.VITE_PAYMENT_STATUS_UPDATE_API_PATH,
  PLACE_IN_DINING_ORDER: import.meta.env.VITE_PLACE_IN_DINING_ORDER,
  GET_IN_DINING_ORDERS: import.meta.env.VITE_GET_IN_DINING_ORDERS,
  UPDATE_IN_DINING_ORDERS: import.meta.env.VITE_UPDATE_IN_DINING_ORDERS,
  GET_INDINING_ORDERS: import.meta.env.VITE_GET_INDINING_ORDERS,

  // Table Management API Paths
  TABLE_AVAILABILITY: import.meta.env.VITE_TABLE_AVAILABILITY,
  TABLE_RESERVATION: import.meta.env.VITE_TABLE_RESERVATION,
  MAKE_RESERVATION: import.meta.env.VITE_MAKE_RESERVATION,
  GET_TABLE_STATUS: import.meta.env.VITE_GET_TABLE_STATUS,

  // Payment API Paths
  MAKE_PAYMENT: import.meta.env.VITE_MAKE_PAYMENT,
  PAYMENT_STATUS_API_PATH: import.meta.env.VITE_PAYMENT_STATUS_API_PATH,

  // Integrations API Paths (V2)
  INTEGRATIONS_API_PATH: import.meta.env.VITE_INTEGRATIONS_API_PATH,
  
  // Subscription API Paths
  SUBSCRIPTION_API_PATH: import.meta.env.VITE_SUBSCRIPTION_API_PATH,
} as const;

export default ENDPOINTS;
